import React, {useEffect, useRef} from 'react';

const HomeVideo = ({active, setActive}) => {
  const refVideo = useRef();

  useEffect(() => {
    if (!refVideo.current) {
      return;
    }

    refVideo.current.defaultMuted = true;
    refVideo.current.muted = true;
    refVideo.current.playsInline = true;
    refVideo.current.webkitPlaysinline = true;
    refVideo.current.play();

    refVideo.current.addEventListener('timeupdate', () => {
      if (refVideo.current.currentTime > 4 && active !== 1) {
        setActive(1);
      }

      if (refVideo.current.currentTime > 7 && active !== 2) {
        setActive(2);
      }

      if (refVideo.current.currentTime > 12 && active !== 0) {
        setActive(0);
      }
    });

    refVideo.current.addEventListener('ended', () => {
      setTimeout(() => {
        setActive(0);
      }, 1000);
    });
  }, []);

  const playVideo = () => {
    if (!refVideo.current) {
      return;
    }

    refVideo.current.play();
  };

  return (
    <div className="pod-home-video">
      <video autoPlay muted ref={refVideo} onClick={playVideo}>
        <source src="/videos/homepage.mp4" type="video/mp4" />
      </video>
    </div>
  );
}

export default HomeVideo;
